import { Box, Heading } from '@zillow/constellation-10';
import React, { useContext } from 'react';
import { css } from '@/styled-system/css';
import { InboxPageMobileView } from '../../types/InboxPageMobileView';
import useDevices from '../../hooks/useDevices';
import { InboxPageContext } from '../../contexts/InboxPageContextProvider';
import FiltersPopover from '../FiltersPopover';
import FoldersModule from '../FoldersModule';
import RentalJourneyFilters from '../RentalJourneyFilters';
import { StyledFiltersModuleContainer, StyledHeader, StyledViewByModuleContainer } from './StyledComponents';

export const RentalJourneyFiltersWrapperStyles = css.raw({
  gridRow: '2 / 3',
  justifySelf: 'start',
  width: '100%',
  gridColumn: '3 / -1',
  overflowX: 'auto',
});

/**
 * This component contains all the content above the messaging portion of Inbox Page
 * such as the read filters, folders, and Rental Journey filters
 */
const InboxHeader = () => {
  const noLeads = false;
  const { mobileView } = useContext(InboxPageContext);
  const { isMobileView } = useDevices();
  const isConversationListViewOnMobile = mobileView === InboxPageMobileView.ConversationList;

  return (
    <StyledHeader $hideOnMobile={!noLeads && !isConversationListViewOnMobile} $isMobile={isMobileView}>
      <Heading level={1} fontFamily="heading-alt" css={{ gridColumn: '1/7', textStyle: { xlDown: 'h4', xl: 'h3' } }}>
        Messages
      </Heading>

      <Box css={RentalJourneyFiltersWrapperStyles}>
        <RentalJourneyFilters />
      </Box>

      <StyledFiltersModuleContainer>
        <FiltersPopover />
      </StyledFiltersModuleContainer>

      <StyledViewByModuleContainer>
        <FoldersModule />
      </StyledViewByModuleContainer>
    </StyledHeader>
  );
};

export default InboxHeader;
